import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  set(key: string, value: any) {
    localStorage.setItem(key, value !== undefined ? JSON.stringify(value) : null);
  }

  get(key: string) {
    const itemStr = localStorage.getItem(key);
    return itemStr !== undefined ? JSON.parse(itemStr) : null;
  }

  setWithExpiry(key, value, ttl) {
    const now = new Date();

    const item = {
      value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
